document.addEventListener("DOMContentLoaded", function () {
  // Stock message container
  var stockMessage = document.getElementById("stock-message");
  var variantSelect = document.querySelector('[name="id"]'); // Variant dropdown or selector

  if (variantSelect && stockMessage) {
    // Listen for changes to the variant dropdown
    variantSelect.addEventListener("change", function () {
      var selectedVariantId = this.value; // Get the selected variant ID

      // Check if inventory exists for the selected variant
      if (variantInventory[selectedVariantId] !== undefined) {
        var stock = variantInventory[selectedVariantId];
        
        // Show message if stock is below 3
        if (stock > 0 && stock < 3) {
          stockMessage.textContent = `${stock} left`;
          stockMessage.classList.remove("out-of-stock"); // Remove out-of-stock class if previously added
          stockMessage.classList.add("low-stock"); // Add low-stock class
        } 
        // Show message if the item is out of stock
        else if (stock === 0) {
          stockMessage.textContent = "Sorry, this item is out of stock.";
          stockMessage.classList.remove("low-stock"); // Remove low-stock class if previously added
          stockMessage.classList.add("out-of-stock"); // Add out-of-stock class
        } 
        // Clear message if stock is 3 or more
        else {
          stockMessage.textContent = "";
          stockMessage.classList.remove("low-stock", "out-of-stock"); // Remove both classes
        }
      } else {
        stockMessage.textContent = "Please select a variant.";
        stockMessage.classList.remove("low-stock", "out-of-stock"); // Remove both classes
      }
    });

    // Trigger the change event on page load to display stock for the first variant
    variantSelect.dispatchEvent(new Event("change"));
  }
});
